import {
  CreateTemplateV3Body,
  UpdateTemplateV3Body,
} from '@ulysses-inc/harami_api_client'
import { denormalize } from 'normalizr'
import { alignResponseTimeMeasurements } from 'src/state/ducks/templates/function'
import { SchemaTemplatePages } from 'src/state/ducks/templates/schemas'
import { TemplateArgs } from 'src/state/ducks/templates/types'

/**
 * TemplateArgs から v3 統合エンドポイント用のリクエストボディを組み立てる共通処理。
 *
 * - alignResponseTimeMeasurements: 時間計測ノードの subType を設定
 * - denormalize: 正規化された state からページ構造を復元
 *
 * 表の固定行セルの正規化(normalizeTableSections)はここでは行わない。
 * FE バリデーションが正規化後のノードを読む必要があるため saveTemplate 入口で
 * 実施済みで、表を持てないグリッドひな形の保存経路には不要のため。
 */
const buildCommonBody = (args: TemplateArgs) => {
  // Redux state を直接変異させないようコピーしてから変換する
  const templateNodes = structuredClone(args.templateNodes)
  alignResponseTimeMeasurements(templateNodes)

  const pages = denormalize(args.templatePageIds, SchemaTemplatePages, {
    templatePages: args.templatePages,
    nodes: templateNodes,
  })

  const template = {
    name: args.name,
    isShowScore: args.isShowScore,
    isEditable: args.isEditable,
    isExcelConversion: args.isExcelConversion,
    isHideQuestionOptions: args.isHideQuestionOptions,
    isAudit: args.isAudit,
    isKeyboard: args.isKeyboard,
    layoutType: args.layoutType,
    hasVariables: args.hasVariables,
    manuals: args.manuals,
    icons: args.icons,
    multipleChoiceSets: args.multipleChoiceSets.flatMap(mcs =>
      mcs.uuid ? [{ uuid: mcs.uuid }] : [],
    ),
    approvalFlows: args.approvalFlowId
      ? [{ id: args.approvalFlowId }]
      : undefined,
    placeNodes: args.placeNodes,
  }

  const rule = args.templateReportNamingRulesTemplateNodeUuid
    ? {
        items: [
          {
            templateNodeUUID: args.templateReportNamingRulesTemplateNodeUuid,
          },
        ],
      }
    : undefined

  const hints = args.templateHints.flatMap(hint =>
    hint.id && hint.name ? [{ id: hint.id, name: hint.name }] : [],
  )

  return { template, pages, rule, hints, masterUuid: args.masterUuid }
}

export const buildCreateTemplateV3Body = (
  args: TemplateArgs,
): CreateTemplateV3Body => {
  const { template, pages, rule, hints, masterUuid } = buildCommonBody(args)
  return { template, pages, rule, masterUuid, hints }
}

export const buildUpdateTemplateV3Body = (
  args: TemplateArgs,
): UpdateTemplateV3Body => {
  const { template, pages, rule, hints, masterUuid } = buildCommonBody(args)
  return { template, pages, rule, masterUuid, hints }
}
